export function doesWorkSkillExist(jobId, workSkills) {

  return workSkills.some(s => s.job_title === jobId);
}
